<template>
  <nav class="route-subnav" :aria-label="`${home?.name || 'Module'} navigation`">
    <div class="route-subnav-inner">
      <button type="button" class="route-subnav-home" @click="handleActive(home)">
        <LayoutGrid :size="17" aria-hidden="true" />
        <span>{{ home?.name }}</span>
      </button>

      <div class="route-subnav-tabs" role="list">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="route-subnav-tab"
          :class="{ 'is-active': tab.id == currTab?.id }"
          :aria-current="tab.id == currTab?.id ? 'page' : undefined"
          @click="handleActive(tab)"
        >
          <span>{{ tabLabel(tab) }}</span>
          <span class="route-subnav-badge" v-if="tabBadge(tab)">{{ tabBadgeLabel(tab) }}</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { LayoutGrid } from "@lucide/vue";

export default {
  name: "HeaderSubComponent",
  components: { LayoutGrid },
  emits: ["active"],
  props: ["home", "tabs", "shorts", "currTab", "color"],
  setup(props, context) {
    const handleActive = (value) => context.emit("active", value);
    const tabLabel = (tab) => props.shorts ? tab?.title?.split(" ")[0] : tab?.title;
    const tabBadge = (tab) => Number(tab?.badge || 0);
    const tabBadgeLabel = (tab) => tabBadge(tab) > 99 ? "99+" : tabBadge(tab);

    return { handleActive, tabBadge, tabBadgeLabel, tabLabel };
  },
};
</script>

<style scoped>
.route-subnav {
  background: var(--ui-background);
  border-bottom: 1px solid var(--ui-border);
  box-shadow: none;
  color: var(--ui-foreground);
  height: auto;
  line-height: normal;
  min-height: 3.75rem;
  overflow: hidden;
  width: 100%;
}
.route-subnav-inner {
  align-items: center;
  display: flex;
  gap: 0;
  margin: 0 auto;
  max-width: var(--ui-content-width);
  min-height: 3.75rem;
  padding: 0 2rem;
  width: 100%;
}
.route-subnav-home,
.route-subnav-tab {
  align-items: center;
  background: transparent;
  border: 0;
  color: var(--ui-muted-foreground);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--ui-font-sans);
  font-size: 0.875rem;
  font-weight: 500;
  gap: 0.45rem;
  min-height: 2.25rem;
  white-space: nowrap;
}
.route-subnav-home {
  border-right: 1px solid var(--ui-border);
  color: var(--ui-foreground);
  flex: 0 0 auto;
  font-weight: 600;
  margin-right: 0.8rem;
  padding-right: 1rem;
}
.route-subnav-tabs {
  align-items: center;
  display: flex;
  gap: 0.25rem;
  margin-left: 0;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}
.route-subnav-tabs::-webkit-scrollbar { display: none; }
.route-subnav-tab { border-radius: calc(var(--ui-radius) - 3px); padding: 0 0.7rem; }
.route-subnav-tab:hover { background: transparent; color: var(--ui-foreground); }
.route-subnav-tab.is-active { background: transparent; color: var(--ui-foreground); font-weight: 600; }
.route-subnav-badge {
  align-items: center;
  background: var(--ui-muted);
  border: 1px solid var(--ui-border);
  border-radius: 999px;
  color: var(--ui-muted-foreground);
  display: inline-flex;
  font-size: 0.62rem;
  height: 1.15rem;
  justify-content: center;
  min-width: 1.15rem;
  padding: 0 0.3rem;
}
@media (max-width: 767px) {
  .route-subnav-inner { align-items: stretch; flex-direction: column; gap: 0; padding: 0.45rem 1rem; }
  .route-subnav-home { border-right: 0; margin: 0; min-height: 2rem; padding: 0 0.35rem; }
  .route-subnav-tabs { margin-left: 0; width: 100%; }
  .route-subnav-tab { flex: 0 0 auto; }
}
</style>
